@if (buttonIcon) {
    <div class="d-flex">
        <button color="primary" mat-icon-button class="upload-button" (click)="iconFileInput.click()">
            @if (uploading) {
                <i class="fas fa-spinner fa-spin"></i>
            } @else {
                <img [src]="icon" />
            }
        </button>
        <input #iconFileInput (change)="uploadFile($event)" hidden multiple type="file" />
    </div>
} @else {
    <div class="d-flex">
        <button color="primary" mat-button class="upload-button" (click)="textFileInput.click()">
            @if (uploading) {
                <i class="fas fa-spinner fa-spin"></i>
            } @else {
                <i class="fas fa-upload"></i>
            }
            Uploaden
        </button>
        <input #textFileInput (change)="uploadFile($event)" hidden multiple type="file" />
    </div>
}
